import { render, staticRenderFns } from "./vue-marquee-slider.vue?vue&type=template&id=269caf60"
import script from "./vue-marquee-slider.vue?vue&type=script&lang=js"
export * from "./vue-marquee-slider.vue?vue&type=script&lang=js"
import style0 from "./vue-marquee-slider.vue?vue&type=style&index=0&id=269caf60&prod&lang=css&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports